var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { dataSelectorId } from '../AdvancedFilter';
var Icon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto;\n    path {\n        fill: ", ";\n    }\n"], ["\n    margin: auto;\n    path {\n        fill: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorControlIcon;
});
export var FilterIcon = function () { return (React.createElement(Icon, { viewBox: "0 0 32 32", "data-selector-id": dataSelectorId.filterIcon },
    React.createElement("path", { d: "M.08.28l12.38 11.33v20.11l7.04-5.25V11.61h.03L31.92.28H.08z", "data-name": "Layer 1" }))); };
var templateObject_1;
//# sourceMappingURL=FilterIcon.js.map